<template>
	<div class="result">
		<transition name="slide-fade">
			<div class="answer-wrap">
				<div class="answer-title">
					★熟睡度100％
					<div class="text">とても良い状態です！</div>
				</div>
				<div class="answer-body">
					<p>睡眠の質と時間を、どちらもしっかり確保できているようです。<br>このままキープを目指しつつ、年齢や環境による変化が現れた際は臨機応変に対応していきましょう。</p>
					<div class="sub-cts"><h2>★さらにぐっすり眠るためには？</h2>
						<p>寝室の環境、肌触りのよい寝間着にこだわったり、アロマオイル等を使ったり、ハーブティーを飲んだりして、睡眠をもっと楽しみましょう！</p>
					</div>
					<div class="sub-cts">
						<h2>▼こちらもCHECK</h2>
						<ul>
							<li><a href="https://xn--z8js3azm.com/beauty/3">ぐっすり眠れる「寝室づくり」の秘訣とは？スグできるコツを教えます</a></li>
						</ul>
					</div>
				</div>
				<div class="btn-area">
					<button @click="next(0)" class="btnReset">スタートに戻る</button>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
export default {
	name: 'ResultCts01',
	methods: {
		next(page) {
			this.$store.dispatch('next', page)
		},
		onComplete: function () {
			this.btnFlg = true;
		}
	}
}
</script>
